import api from "./apiConfig";

export const REGISTER_ANNOUNCEMENT = async (data) => {
	try {
		const response = await api.post("/announcements", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_ANNOUNCEMENTS = async () => {
	try {
		const response = await api.get("/announcements");
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_ANNOUNCEMENT = async (id, data) => {
	try {
		const response = await api.put(`/announcements/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar:", error);
		throw error;
	}
};

export const DELETE_ANNOUNCEMENT = async (id) => {
	try {
		const response = await api.delete(`/announcements/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al eliminar:", error);
		throw error;
	}
};